import useFeatures from "@hooks/use-features";
import classNames from "classnames";
import Badge from "@components/core/Badge/Badge";
import catalogContexts from "@utils/constants/catalogContexts";

function ProductDiscountSticker({ product, context, className }) {
  const features = useFeatures();

  const priceDiff = product?.retail_price - product?.current_price;
  const calculatedDiscountPercent = Math.round((priceDiff / product?.retail_price) * 100);
  const displayDiscountBadge = calculatedDiscountPercent > features?.min_discount_to_display;

  if (!product?.id || !displayDiscountBadge || context !== catalogContexts.sales) return null;

  return (
    <div className={classNames("catalog-product-discount-sticker-container", className)}>
      <Badge
        variant="tertiary"
        className="me-2"
      >
        -{calculatedDiscountPercent}%
      </Badge>
    </div>
  );
}

export default ProductDiscountSticker;
